import { useLocalStorage } from 'usehooks-ts';

import { useAuthUser } from 'authOld/hooks';
import { LocalStorageKeys } from 'coreOld/enums';
import { IRequestFilters } from 'coreOld/types';
import { isEmptyObject } from 'coreOld/utils';

const DEFAULT_TIME = 15 * 60 * 1000; // 15 minutes

export const useSaveFilters = () => {
  const [filters, setFilters] = useLocalStorage(LocalStorageKeys.FILTERS, null);

  const { user } = useAuthUser();

  const saveFilters = (key: string, filters: IRequestFilters) =>
    setFilters((prevFilters) => ({
      ...prevFilters,
      [`${key}-${user?.id}`]: { filters, time: Date.now() },
    }));

  const getFilters = (key: string) => {
    const userKey = `${key}-${user?.id}`;

    if (!filters || !filters[userKey] || isEmptyObject(filters[userKey].filters)) {
      return {};
    }

    const { filters: currentFilters, time } = filters[userKey];

    if (Date.now() - time > DEFAULT_TIME) {
      setTimeout(() => clearFiltersByKey(userKey), 1000);

      return {};
    }

    return currentFilters;
  };

  const clearFiltersByKey = (key: string) => {
    setFilters((prev) => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { [key]: _, ...rest } = prev;

      return rest;
    });
  };

  return {
    saveFilters,
    getFilters,
    clearFiltersByKey,
  };
};
